import { useCallback, useState } from "react";

import { useNavigate, Outlet, useMatch } from "react-router-dom";

import { Trans } from "react-i18next";
import { QrReader, OnResultFunction } from "react-qr-reader";

import Typography from "@mui/material/Typography";

import Title from "../../components/Title";
import BackButton from "../../components/BackButton";
import Curve from "../../components/Animations/PageTransitions/Curve";

// import usePageTracking from "../../bit/tracking/usePageTracking";

const ViewFinder = () => (
  <svg
    viewBox="0 0 100 100"
    style={{
      top: 0,
      left: 0,
      zIndex: 1,
      boxSizing: "border-box",
      position: "absolute",
      width: "100%",
      height: "100%",
    }}
  >
    <path
      fill="none"
      d="M13,0 L0,0 L0,13"
      stroke="rgba(255, 0, 0, 0.5)"
      strokeWidth="0.5rem"
    />
    <path
      fill="none"
      d="M0,87 L0,100 L13,100"
      stroke="rgba(255, 0, 0, 0.5)"
      strokeWidth="0.5rem"
    />
    <path
      fill="none"
      d="M87,100 L100,100 L100,87"
      stroke="rgba(255, 0, 0, 0.5)"
      strokeWidth="0.5rem"
    />
    <path
      fill="none"
      d="M100,13 L100,0 87,0"
      stroke="rgba(255, 0, 0, 0.5)"
      strokeWidth="0.5rem"
    />
  </svg>
);

const QRCodeScanner = () => {
  const match = useMatch({ path: "/scanner/:action" });

  const action = match?.params?.action;

  const navigate = useNavigate();

  // usePageTracking({
  //   page: "scanner",
  // });

  const [error, setError] = useState<Error>();

  const onResult: OnResultFunction = useCallback((result, error) => {
    if (error) {
      setError(error);
      return;
    }

    if (!result) {
      return;
    }

    const data = result.getText();

    const regex = /^\d+$/;

    if (data && regex.test(data) && data.length === 6) {
      navigate(`/access/${action}/${data}`);
    }
  }, []);

  return (
    <Curve>
      <div className="d-flex align-items-center flex-column">
        <BackButton to={`/access/${action}`} />
        <Title>
          <Typography variant="h1">
            <Trans i18nKey="QRCodeScanner:title" />
          </Typography>
          <Typography variant="h4" className="font-weight-regular mt-5">
            <Trans i18nKey="QRCodeScanner:subtitle" />
          </Typography>
        </Title>

        <div className="qr-scanner">
          <div style={{ width: "100%", margin: "auto" }}>
            <QrReader
              onResult={onResult}
              scanDelay={1000}
              constraints={{ facingMode: "user", aspectRatio: 1 }}
              ViewFinder={ViewFinder}
            />
          </div>
          {error && (
            <Typography
              variant="h3"
              className="position-absolute text-center text-danger p-4"
            >
              {error?.message}
            </Typography>
          )}
        </div>
      </div>
      <Outlet />
    </Curve>
  );
};

export default QRCodeScanner;
